"use client"

import clsx from "clsx"
import { Announcement } from "src/components/sections/header/Announcement"
import { Header, headerHeightClassName } from "src/components/sections/header/Header"
import { useStickyHeaderProps } from "src/components/sections/header/stickyHeader"
import { SanityAnnouncementData } from "src/data/sanity/types"

export type StickyHeaderProps = {
  announcement?: SanityAnnouncementData | null
  checkout?: boolean
}

export const StickyHeader = ({ announcement, checkout }: StickyHeaderProps) => {
  const { stickyRef, stickyClassName } = useStickyHeaderProps()

  return (
    <>
      <div className="invisible">{announcement && <Announcement {...announcement} />}</div>
      <div className={headerHeightClassName} />

      <div ref={stickyRef} className={clsx(stickyClassName, "shadow backdrop-blur-lg")}>
        {announcement && <Announcement {...announcement} />}
        <Header checkout={checkout} announcement={announcement} />
      </div>
    </>
  )
}
